<template>
    <div
        v-tooltip="row.tooltip"
        class="m-checkList__row"
        :class="[
            { 'm-checkList__row--active': rowCheckbox },
            { 'm-checkList__row--disabled': disabled },
            { 'm-checkList__row--blocked': row.blocked }
        ]"
        @click="onSelectRow(!rowCheckbox)"
    >
        <div @click.stop>
            <ui-checkbox-input
                v-model="rowCheckbox"
                class="text-primary text-sm"
                :name="`row-${row.id}`"
                :label="row.label"
                :type="type"
                :disabled="disabled"
            />
        </div>
        <img
            v-if="row.img"
            :height="row.imgHeight"
            :src="row.img"
        />
        <slot name="rowDetails" :row="row" />
        <a-icon
            v-if="row.iconTooltip"
            v-tooltip="row.iconTooltip"
            icon="Info"
            class="m-checkList__row-icon text-primary"
        />
    </div>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true
        },
        selectedRows: {
            type: Array,
            default: () => []
        },
        selectRow: {
            type: Function,
            default: () => {}
        },
        type: {
            type: String,
            default: 'checkbox'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rowCheckbox: {
            get() {
                return !!this.selectedRows?.find(row => row?.id === this.row.id)
            },
            set(value) {
                this.onSelectRow(value)
            }
        }
    },
    methods: {
        onSelectRow(value) {
            if (this.disabled) return
            this.selectRow({
                value,
                id: this.row.id
            })
        }
    }
}
</script>
